export default __webpack_public_path__ + "static/media/sketch2.3c9d9de0.jpg";